<template>
  <admin-payment title="Pagina de Pagamento">
    <div class="row">
      <div class="col-lg-2 col-xs-12"></div>
      <div v-if="!plan.id">
        <h1>Plano não encontrado</h1>
      </div>

      <div v-if="plan.id" class="col-lg-8 col-xs-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 col-lg-12">
                <h4 class="card-title">Assinatura do plano {{plan.name}} concluida</h4>
                <pre>{{plan.description}}</pre>
                <p>
                  <b>Total de vagas:</b>
                  {{plan.amount_jobs}}
                </p>
                <p>
                  <b>Total de usuários:</b>
                  {{plan.amount_recruiters}}
                </p>
                <p class="f17">
                  <b>Total:</b>
                  <span
                    class="f20"
                  >R$ {{ plan.price ? parseFloat(plan.price).toFixed(2).replace('.', ',') : "0,00" }}</span>
                </p>
                <p>Tipo de pagamento: {{payment_method[transaction.payment_method]}}</p>
                <p
                  v-if="transaction.payment_method == 'boleto'"
                >Para acelerar o processo você pode realizar o pagamento do boleto e enviar o comprovante para contato@projetocurriculo.com</p>
                <h4>
                  Status:
                  <b>{{status[transaction.status]}}</b>
                </h4>
              </div>
              <div v-if="transaction.boleto_url" class="col-lg-6 col-xs-12">
                <a :href="transaction.boleto_url" target="_blank">
                  <button
                    type="button"
                    class="mt-4 btn btn-degrade normal-degrade"
                  >Clique aqui para baixar o boleto</button>
                </a>
              </div>
              <div
                v-if="transaction.status == 'paid' || transaction.status == 'authorized'"
                class="col-lg-6 col-xs-12"
              >
                <inertia-link href="/recruiters/dashboard">
                  <button
                    type="button"
                    class="mt-4 btn btn-degrade normal-degrade"
                  >Começar a usar a Jovool agora</button>
                </inertia-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-payment>
</template>

<script>
export default {
  props: ["plan", "subscription", "transaction"],
  data: () => ({
    payment_method: {
      boleto: "Boleto",
      credit_card: "Cartão de crédito",
    },
    status: {
      processing: "Transação está em processo de autorização.",
      authorized: "Transação foi autorizada.",
      paid: "Transação paga.",
      refunded: "Transação estornada completamente.",
      waiting_payment: "Transação aguardando pagamento ",
      pending_refund:
        "Transação do tipo Boleto e que está aguardando confirmação do estorno solicitado.",
      refused: "Transação recusada, não autorizada.",
      chargedback: "Transação sofreu chargeback.",
      analyzing:
        "Transação encaminhada para a análise manual feita por um especialista em prevenção a fraude.",
      pending_review:
        "Transação pendente de revisão manual por parte do lojista.",
    },
  }),
};
</script>
